var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        [
          _vm.shouldDisplayLicenseRecapContainer
            ? _c(
                "div",
                { staticClass: "license-recap__container" },
                [
                  _c(
                    "Card",
                    {
                      staticClass: "subscription-overview__card",
                      attrs: {
                        background: "lightgrey",
                        borderColor: "gray-40",
                        padding: 4
                      }
                    },
                    [
                      _vm.shouldDisplayAlertSubscription
                        ? _c("CompassAlert", {
                            attrs: {
                              type: "warning",
                              description: _vm.descriptionAlertSubscription,
                              showClose: false,
                              action: _vm.actionAlertSubscription
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "subscription-overview__card-information"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "subscription-overview__summary" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subscription-overview__summary-plan"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t.__(
                                              "sellsyaccountmanager.SubscriptionManager.Overview.label_plan_subscription"
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "subscription-overview__summary-plan-tag typographies-paragraph-caps-medium-semibold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.plan) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subscription-overview__summary-date"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t.__(
                                              "sellsyaccountmanager.SubscriptionManager.Overview.label_date_subscription"
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-regular"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.period) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.canCancelSubscription
                                    ? _c("SubscriptionTag", {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "sellsyaccountmanager.SubscriptionManager.Overview.yearly_contract_term"
                                          ),
                                          variant: "renew"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subscription-overview__summary-recurring"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t.__(
                                              "sellsyaccountmanager.SubscriptionManager.Overview.label_recurring_subscription"
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-regular"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.type) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "aright" },
                            [
                              !_vm.isChargebeeProvider
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "flex-row flex-right" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "fs-10 bold" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$filters.numberFormatWithOptions(
                                                    _vm.amount.total,
                                                    _vm.numformat
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-column ov-hidden mt-1"
                                          },
                                          [
                                            _c("div", { staticClass: "bold" }, [
                                              _c(
                                                "span",
                                                { staticClass: "fs-4" },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.numformat
                                                          .currencysymbol
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "fs-3" },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$l10n.__("HT")
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "grey fs-3" },
                                              [
                                                _vm._v(
                                                  "/" + _vm._s(_vm.intervalName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "fs-2" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.discount) +
                                          "\n                        "
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subscription-overview__actions-subscription"
                                },
                                [
                                  _vm.shouldDisplayEditSubscriptionBtn
                                    ? _c(
                                        "CompassTooltip",
                                        {
                                          attrs: {
                                            disabled: !_vm.disableChargebeeUpdateSubscription,
                                            content: _vm.$t.__(
                                              "sellsyaccountmanager.SubscriptionManager.Overview.self_service_inaccessible_by_transfer"
                                            )
                                          }
                                        },
                                        [
                                          _c("CompassButton", {
                                            staticClass:
                                              "license-overview__btn-edit-subscription",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "common.actions.edit_subscription"
                                              ),
                                              disabled:
                                                _vm.hasRenewCart ||
                                                _vm.disableChargebeeUpdateSubscription ||
                                                _vm.renewScheduled
                                                  .hasRenewScheduled
                                            },
                                            on: { click: _vm.upsellCart }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canCancelSubscription
                                    ? _c("CompassButton", {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.actions.cancel_subscription"
                                          ),
                                          type: "tertiary"
                                        },
                                        on: {
                                          click: _vm.handleCancelSubscription
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isChargebeeProvider
                    ? _c("ManageChargebeeAccount")
                    : _c(
                        "card",
                        {
                          staticClass: "ml-4 wp-4 fs-3 p-4 lh-big",
                          attrs: { borderColor: "gray-40" }
                        },
                        [
                          _c("h5", { staticClass: "bold m-0 mb-2 dinline" }, [
                            _vm._v(
                              _vm._s(_vm.$l10n.__("Information de facturation"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.billingAddress.client_name))
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.billingContact.first_name +
                                  " " +
                                  _vm.billingContact.last_name
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.billingAddress.address_line_1))
                          ]),
                          _vm._v(" "),
                          _vm.billingAddress.address_line_2 != ""
                            ? _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.billingAddress.address_line_2) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.billingAddress.postal_code) +
                                " " +
                                _vm._s(_vm.billingAddress.city) +
                                "\n                " +
                                _vm._s(_vm.billingAddress.country) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grey mt-2" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.billingContact.email +
                                    " - " +
                                    _vm.billingContact.phone_number
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod === "card" && !_vm.isChargebeeProvider
            ? _c("payment-card-manager", { staticClass: "mt-3" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "h3",
            {
              class: [
                "lh-24",
                _vm.shouldDisplayLicenseRecapContainer ? "mt-6" : "mt-0"
              ]
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$l10n.__("Mes licences")) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-3 lh-20 fs-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__(
                    "Votre offre comporte plusieurs niveaux de licence afin que vos collaborateurs puissent utiliser les différents modules proposés dans Sellsy. Vous pouvez gérer l’attribution des licences à vos collaborateurs dans l’onglet : "
                  )
                ) +
                "\n        "
            ),
            _c(
              "a",
              {
                staticClass: "semibold pointer hover-primary-100",
                on: {
                  click: function($event) {
                    return _vm.$emit("go-to-staffs")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Gestion des licences.")) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("licences", {
            attrs: {
              licenses: _vm.licenses,
              versionedLicenses: _vm.versionedLicenses
            }
          }),
          _vm._v(" "),
          _vm.hasPlugins
            ? _c("plugins-summary", {
                attrs: { activePlugins: _vm.activePlugins }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loaded
            ? _c("QuotaSummary", {
                attrs: {
                  isChargebeeProvider: _vm.isChargebeeProvider,
                  chargebeeThirdPartyPayerId: _vm.chargebeeThirdPartyPayerId,
                  licenseAssignement: _vm.licenseAssignement
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldDisplayCancelSubscriptionCancellationDialog
            ? _c("CancelSubscriptionCancellationDialog", {
                attrs: { subscriptionId: _vm.chargebeeSubscriptionId },
                on: {
                  onClose: function($event) {
                    _vm.shouldDisplayCancelSubscriptionCancellationDialog = false
                  },
                  onSuccess: _vm.fetchChargebeeSubscriptionDatas
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }